import { render, staticRenderFns } from "./CPauseLinePacking.vue?vue&type=template&id=fd4fb1d4&scoped=true"
import script from "./CPauseLinePacking.vue?vue&type=script&lang=js"
export * from "./CPauseLinePacking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4fb1d4",
  null
  
)

export default component.exports